import React, { useState, useEffect } from "react";
import NotesModal from "../NotesModal/NotesModal";
import "./RatiosCards.css";
import DepassementModal from "../DepassementModal/DepassementModal";
import { ticketService } from "../../../../service/ticketService";

const RatiosCards = ({ ratios, notes }) => {
  const averageRating = notes?.moyenne ? notes.moyenne.toFixed(1) : "0.0";
  const [showNotesModal, setShowNotesModal] = useState(false);
  const [showDepassementModal, setShowDepassementModal] = useState(false);
  const [depassementEtablissements, setDepassementEtablissements] = useState(
    []
  );

  useEffect(() => {
    const fetchData = async () => {
      try {
        const now = new Date();
        const year = now.getFullYear();
        const month = (now.getMonth() + 1).toString().padStart(2, "0");

        const firstDay = `${year}-${month}-01`;
        const lastDay = `${year}-${month}-${new Date(
          year,
          now.getMonth() + 1,
          0
        ).getDate()}`;

        const response =
          await ticketService.getEstablishmentsWithMoreThanFourTickets({
            dateDebut: firstDay,
            dateFin: lastDay,
          });

        setDepassementEtablissements(
          response?.data?.result
            ?.etablissementsAvecDepassementNbreTicketsMois ?? []
        );
      } catch (error) {
        console.error("Error fetching establishments:", error);
      }
    };

    fetchData();
  }, []);

  const handleCardClick = (cardKey) => {
    switch (cardKey) {
      case "averageRating":
        setShowNotesModal(true);
        break;
      case "etablissementsAvecDepassementNbreTicketsMois":
        setShowDepassementModal(true);
        break;
      default:
        break;
    }
  };

  const StarIcon = ({ color, size = 24 }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill={color}>
      <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
    </svg>
  );

  const AlertIcon = ({ color, size = 24 }) => (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="12" cy="12" r="10"></circle>
      <line x1="12" y1="8" x2="12" y2="12"></line>
      <line x1="12" y1="16" x2="12.01" y2="16"></line>
    </svg>
  );

  const cardData = [
    {
      key: "delaiPriseEnChargeMoyen",
      title: "Prise en charge",
      value: ratios?.delaiPriseEnChargeMoyen || "--",
      unit: "",
      colorClass: "blue",
      hasDetails: false,
    },
    {
      key: "delaiParcouruMoyen",
      title: "Moyen de parcours",
      value: ratios?.delaiParcouruMoyen || "--",
      unit: "",
      colorClass: "orange",
      hasDetails: false,
    },
    {
      key: "delaiResolutionMoyen",
      title: "Moyen de résolution",
      value: ratios?.delaiResolutionMoyen || "--",
      unit:  "",
      colorClass: "green",
      hasDetails: false,
    },
    ...(averageRating > 0
      ? [
        {
          key: "averageRating",
          title: "Note moyenne",
          value: averageRating,
          unit: "",
          colorClass: "yellow",
          hasDetails: true,
          icon: <StarIcon color="#FFC107" size={20} />,
        },
      ]
      : []),
    ... (depassementEtablissements?.length > 0
      ? [

        {
          key: "etablissementsAvecDepassementNbreTicketsMois",
          title: "Étab. en dépassement (ce mois)",
          value: depassementEtablissements?.length || 0,
          unit: "",
          colorClass: "red",
          hasDetails: true,
          icon: <AlertIcon color="#EF4444" size={20} />,
        }
      ]
      : []),
  ];

  return (
    <div className="ratios-container">
      {cardData.map((card) => (
        <div
          key={card.key}
          className={`ratio-card ${card.colorClass} ${card.hasDetails ? "clickable" : ""
            }`}
          onClick={
            card.hasDetails ? () => handleCardClick(card.key) : undefined
          }
        >
          <div className="card-content">
            <div className="title-container">
              {/* {card.icon && <div className="icon-container">{card.icon}</div>} */}
              <p className="card-title">{card.title}</p>
            </div>
            <div className="value-container">
              <span className="card-value">{card.value}</span>
              {card.unit && <span className="card-unit">{card.unit}</span>}
              {card.icon && <div className="card-icon">{card.icon} </div>}
            </div>
            {card.hasDetails && (
              <div className="card-cta">
                {/* <span className="cta-text">Voir les détails</span> */}
                <svg
                  className="cta-icon"
                  width="12"
                  height="12"
                  viewBox="0 0 12 12"
                  fill="none"
                >
                  <path
                    d="M4.5 3L7.5 6L4.5 9"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>
            )}
          </div>
        </div>
      ))}
      <NotesModal
        notes={notes}
        isOpen={showNotesModal}
        onClose={() => setShowNotesModal(false)}
      />
      <DepassementModal
        // etablissements={etablissementsAvecDepassementList}
        isOpen={showDepassementModal}
        onClose={() => setShowDepassementModal(false)}
      />
    </div>
  );
};

export default RatiosCards;
